<section class="p-3">
  <h2 class="title mb-4">Notificaciones</h2>
  <div class="container-fluid h-100 d-flex flex-column">
    <div class="row mb-3">
      <div class="col-12 col-md-4 col-xl-4">
        <div class="p-inputgroup pe-1">
          <!-- <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span> -->
          <input
            pInputText
            type="text"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange($event)"
            placeholder="Buscar notificaciones..."
            class="w-100"
          />
        </div>
      </div>
    </div>

    <div class="row flex-grow-1 overflow-hidden">
      <div class="col-12 col-md-4 h-100 d-flex flex-column border-end pe-0">
        <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 200px)' }">
          <div class="notification-list pe-3">
            @for (n of $notification.notifications(); track n.id) {
              <div
                class="notification-item p-3 mb-2 border rounded cursor-pointer transition-all"
                [class.selected]="selectedNotification()?.id === n.id"
                [class.unread]="!n.isRead"
                (click)="selectNotification(n)"
              >
                <div class="d-flex justify-content-between align-items-start mb-1">
                  <span class="fw-bold text-truncate w-75">{{ n.header }}</span>
                  @if (!n.isRead) {
                    <p-badge
                      severity="danger"
                      value=" "
                      style="height: 1rem; min-width: 1rem"
                    ></p-badge>
                  }
                </div>

                <p class="text-muted small text-truncate mb-1">{{ n.description }}</p>

                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-xs ms-auto text-secondary italic">
                    {{ n.notificationDate | date: 'dd/MM/yyyy HH:mm' }}
                  </span>
                  <!-- <span class="badge" [ngClass]="'bg-' + getSeverity(n.notificationType) + '-subtle text-' + getSeverity(n.notificationType)">
                  {{ n.notificationType }}
                </span> -->
                </div>
              </div>
            } @empty {
              @if (!$notification.isLoading()) {
                <div class="text-center p-5 text-muted">
                  <i class="pi pi-bell-slash fs-1 mb-2"></i>
                  <p>No hay notificaciones</p>
                </div>
              }
            }

            @if ($notification.hasMore()) {
              <div class="text-center py-3">
                <p-button
                  label="Cargar más"
                  [loading]="$notification.isLoading()"
                  [text]="true"
                  (onClick)="loadMore()"
                />
              </div>
            }

            @if ($notification.isLoading()) {
              <div class="text-center py-2">
                <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="4" />
              </div>
            }
          </div>
        </p-scrollPanel>
      </div>

      <div class="col-12 col-md-8 h-100 overflow-auto bg-light-subtle rounded p-4">
        @if (selectedNotification(); as n) {
          <div class="fade-in">
            <div class="d-flex justify-content-between align-items-start mb-4">
              <div>
                <h2 class="h4 fw-bold mb-1">{{ n.header }}</h2>
                <span class="text-secondary small">
                  Recibido el {{ n.notificationDate | date: 'fullDate' }} a las
                  {{ n.notificationDate | date: 'HH:mm' }}
                </span>
              </div>
            </div>

            <p-divider />

            <div class="notification-body bg-white p-4 rounded shadow-sm border mt-4">
              <div [innerHTML]="n.description" class="lh-lg"></div>
            </div>
          </div>
        } @else {
          <div
            class="h-100 d-flex flex-column align-items-center justify-content-center text-muted"
          >
            <i class="pi pi-envelope fs-1 mb-3 opacity-20"></i>
            <p>Selecciona una notificación para ver su contenido</p>
          </div>
        }
      </div>
    </div>
  </div>
</section>
